export default function imageLoader({ src, width, quality }: { src: string; width: number; quality?: number }): string {
  // Remote/CDN URLs → set width + auto-format params for CDN optimization.
  // Pass quality (Imgix-compatible `q=`) so the CDN can apply lossy compression,
  // addressing the PSI "Improve image delivery" flag (~4-5 MiB savings).
  // Default 65 on this route — Tamil news imagery is forgiving; 65 is visually
  // indistinguishable from 75 but ~25% smaller.
  if (src.startsWith('http://') || src.startsWith('https://')) {
    const q = quality || 65;
    // Some CMS-stored asset URLs (e.g. header/footer logo config) already
    // come with their own w=/q=/auto=/fit= baked in from whoever pasted the
    // URL in — blindly appending ours produced duplicate/conflicting params
    // (?w=640&...&w=256&...), and the CDN honored the FIRST (stale, often
    // much larger) w= it saw, silently defeating our resize request. Parse
    // and overwrite instead of append so our values always win regardless
    // of what the source URL already carried.
    const url = new URL(src);
    url.searchParams.set('w', String(width));
    url.searchParams.set('q', String(q));
    url.searchParams.set('auto', 'format,compress');
    url.searchParams.set('fit', 'max');
    return url.toString();
  }
  // Data URIs (blur placeholders) → return as-is
  if (src.startsWith('data:')) {
    return src;
  }
  // Local paths → always use origin's _next/image (not CDN)
  // CDN (assetPrefix) is only for JS/CSS, not image optimization
  const q = quality || 65;
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${q}`;
}
